var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cell-fine",
      class: {
        "cell-fine-red": _vm.record.fine.value > 0,
        "cell-fine_disabled": !_vm.canEdit,
      },
      on: {
        click: function ($event) {
          _vm.canEdit &&
            (_vm.calculateType === "byPeriod"
              ? (_vm.isShowFinesPeriodModal = true)
              : (_vm.isShowFinesPeriodModal = true))
        },
      },
    },
    [
      _vm.calculateType === "byPeriod"
        ? _c("m-show-fines-period-modal", {
            attrs: {
              active: _vm.isShowFinesPeriodModal,
              record: _vm.record,
              "calc-data": _vm.calculationData,
            },
            on: {
              close: function ($event) {
                _vm.isShowFinesPeriodModal = false
              },
              updateFines: _vm.updateFines,
            },
          })
        : _vm._e(),
      _vm.calculateType === "byDate"
        ? _c("m-show-fines-period-modal", {
            attrs: {
              active: _vm.isShowFinesPeriodModal,
              record: _vm.record,
              "calc-data": _vm.calculationData,
            },
            on: {
              close: function ($event) {
                _vm.isShowFinesPeriodModal = false
              },
              updateFines: _vm.updateFines,
            },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "cell-fine-value",
          class: { "cell-fine-value-grey": _vm.record.fine.value == 0 },
        },
        [_vm._v(" " + _vm._s(_vm.record.fine.value) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }